export default {
  styleOverrides: {
    root: {
      textTransform: 'none',
    },
  },
};
